/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const accountModule = require('@utils/account/accountModule');
const analyticsModule = require('@utils/analytics/analyticsModule');
const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const cookiesModule = require('@utils/cookies/cookiesModule');
const getFetchModule = require('@utils/get_fetch/getFetchModule');
const indexModule = require('@utils/index/indexModule');
const swiftypeModule = require('@utils/swiftype/swiftypeModule');
const ProductService = require('./productService');

const productModule = angular
    .module('enervee_utils.product', [
        accountModule.name,
        analyticsModule.name,
        commonModule.name,
        consumersModule.name,
        cookiesModule.name,
        getFetchModule.name,
        indexModule.name,
        swiftypeModule.name,
    ])
    .factory('ProductService', ProductService);

module.exports = productModule;